import { coalesceLocaleField } from '../helpers/coalesceLocaleField'
import { groq } from 'next-sanity'
import { LocaleId } from '@portfolio/configs'
import { createBaseImageProjection } from '../projections/createBaseImageProjection'
import { createMediaProjection } from '../projections/createMediaProjection'

export const createSectionLogosWithTestimonialsProjection = (
  localeId: LocaleId,
) => {
  const MEDIA_PROJECTION = createMediaProjection(localeId)
  const BASE_IMAGE_PROJECTION = createBaseImageProjection(localeId)

  return groq`{
        _key,
        _type,
        spacing,
        topBorder,
        ${coalesceLocaleField('title', localeId)},
        logotypes[] {
          image${MEDIA_PROJECTION}
        },
        testimonialVideos[] {
          ${coalesceLocaleField('personName', localeId)},
          ${coalesceLocaleField('personPosition', localeId)},
          logo${BASE_IMAGE_PROJECTION},
          media${MEDIA_PROJECTION}
        }
      }
  `
}
